import React from "react";
import { CheckIcon, StarIcon, XIcon } from "lucide-react";
import { feelAfter, feelBefore, testimonials } from "../../data/content";
import { CTAButton } from "../CTAButton";
export function Testimonials() {
  return <section className="bg-sand px-4 py-16" data-id="element-264" data-mp="3mg0mup53sxgg">
      <div className="mx-auto max-w-5xl" data-id="element-265" data-mp="3mezeisfh2p2f">
        <h2 className="mx-auto max-w-2xl text-center font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-266" data-mp="3r8kc4jd5lh13">
          What professional case review should feel like
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-267" data-mp="421houdz8cch">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-268" data-mp="91mi798sosrb">
              <div className="flex items-center gap-4" data-id="element-269" data-mp="e1iml9lemm7e">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold" data-id="element-270" data-mp="dywf19yik6p6" />
                <figcaption data-id="element-271" data-mp="2fsc8sfpwe1od">
                  <p className="text-[17px] font-bold text-ink" data-id="element-272" data-mp="2frkcf2oh7zx1">{t.name}</p>
                  <p className="text-[14px] text-muted" data-id="element-273" data-mp="1sk9cyl8xwmdo">{t.role}</p>
                </figcaption>
              </div>
              <div className="mt-4 flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-274" data-mp="1ntkkp3pfrldh">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-275" data-mp="1isn4gwnzl1em" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-ink" data-id="element-276" data-mp="2bjeutdidevu1">“{t.quote}”</blockquote>
            </figure>)}
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-4 md:grid-cols-2" data-id="element-277" data-mp="26llpsnst07vc">
          <div className="rounded-3xl bg-white p-6" data-id="element-278" data-mp="22hxkkbrn9od9">
            <h3 className="text-[18px] font-extrabold uppercase tracking-wide text-red-700" data-id="element-279" data-mp="22ktelp0dfswf">Before</h3>
            <ul className="mt-4 space-y-2.5" data-id="element-280" data-mp="1xlyo00w5x01r">
              {feelBefore.map(t => <li key={t} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-281" data-mp="r1gyw0phybhy">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden data-id="element-282" data-mp="m35p1pz7c0zq" />
                  {t}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-ink p-6 text-white" data-id="element-283" data-mp="sjnxk8kc22ty">
            <h3 className="text-[18px] font-extrabold uppercase tracking-wide text-goldsoft" data-id="element-284" data-mp="el7ucrloiugk">After</h3>
            <ul className="mt-4 space-y-2.5" data-id="element-285" data-mp="im9lsm9cu27z">
              {feelAfter.map(t => <li key={t} className="flex gap-2.5 text-[15px] leading-snug" data-id="element-286" data-mp="4v4uq8k1yi99">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden data-id="element-287" data-mp="4t1tesdg92p8" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <CTAButton className="mt-10" label="I want this kind of case review" data-id="element-288" data-mp="3r45yk2vfm327" />
      </div>
    </section>;
}